import {
    Flex,
    FormControl,
    FormLabel,
    Heading,
    HStack,
    PinInput,
    PinInputField,
    Switch,
    Text,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { VerifyContainer } from '../components/LandingPageComponents/styles/SplashStyles';
import { backbtn } from './dashboard/components/Icons';
import { useDispatch, useSelector } from 'react-redux';
import { clearReq, userLogin, verifyUser } from '../redux/actions/authActions';
import { fetchCurrencies } from 'redux/actions/currencyActions';

const LoginVerification = () => {
    const [otp, setOtp] = useState('');
    const [remember_me, setremember_me] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authReducer = useSelector((state) => state.authReducer);
    const verifyReducer = useSelector((state) => state.verifyReducer);
    const { user, userData } = authReducer;
    const { loading } = verifyReducer;

    let request_id = user?.request_id;
    const token = window.localStorage.getItem('token')
        ? JSON.parse(window.localStorage.getItem('token'))
        : '';

    useEffect(() => {
        // if (!request_id) {
        //     navigate(`/login`);
        // }
    }, [request_id, navigate]);

    useEffect(() => {
        if (token) {
            dispatch(fetchCurrencies());
            navigate(`/dashboard`);
        }
        if (!loading) {
            setOtp('');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, navigate, loading]);

    useEffect(() => {
        const handleSubmit = () => {
            if (request_id) {
                let data = {
                    request_id,
                    otp,
                    remember_me: remember_me ? 1 : 0,
                };
                dispatch(verifyUser(data));
            }
        };
        if (otp && otp.length === 4) {
            handleSubmit();
        }
    }, [dispatch, otp, remember_me, request_id]);

    const handleBack = () => {
        navigate(-1);
        dispatch(clearReq());
    };
    // token ? (
    // <Navigate to="/dashboard" />
    // ) :

    return (
        <VerifyContainer>
            <HStack
                justify="space-between"
                px="27px"
                alignItems="center"
                // fontSize={{ base: '24px', md: '40px', lg: '56px' }}
                display={{ base: 'flex', lg: 'none', sm: 'flex' }}>
                <span onClick={handleBack}>{backbtn}</span>
            </HStack>
            <Flex
                w={{ base: 'full', lg: '450px' }}
                mt={{ base: '0', lg: '50px' }}
                h="full"
                boxSizing="border-box"
                mx={{ base: 'auto' }}
                p={{ base: '0', lg: '45px 24px' }}
                justify="center"
                alignItems="center"
                border={{ base: 'none', lg: '1px solid #F2F4F5' }}
                flexDir="column">
                <Heading
                    as="h2"
                    w="90%"
                    textAlign="center"
                    mt="25px"
                    mb={{ base: '15px', lg: '48px' }}
                    color="#090A0A"
                    fontSize={{ lg: '32px', base: '24px' }}>
                    Enter authentication code
                </Heading>
                <FormControl
                    display="flex"
                    alignItems="center"
                    my="2rem"
                    w="full"
                    justifyContent="center">
                    <FormLabel htmlFor="email-alerts" mb="0">
                        Keep me logged in for a Week
                    </FormLabel>
                    <Switch
                        id="email-alerts"
                        isChecked={remember_me}
                        onChange={() => setremember_me(!remember_me)}
                    />
                </FormControl>
                <Text w="90%" textAlign="center">
                    Enter the 4-digit that we have sent via the email{' '}
                    <b>{userData?.user_identification}</b>
                </Text>

                <HStack mt="32px" gap="14px" fontSize="16px" lineHeight="24px">
                    <PinInput
                        required
                        otp
                        type="alphanumeric"
                        value={otp}
                        placeholder="-"
                        onChange={(value) => setOtp(value)}>
                        <PinInputField
                            borderRadius="50%"
                            border="1px solid #e3e5e6"
                            _focus={{ borderColor: '#6b4eff' }}
                            w="50px"
                            h="50px"
                            color="#090A0A"
                            fontSize="16px"
                            inputMode="numeric"
                        />
                        <PinInputField
                            borderRadius="50%"
                            border="1px solid #e3e5e6"
                            _focus={{ borderColor: '#6b4eff' }}
                            w="50px"
                            h="50px"
                            color="#090A0A"
                            fontSize="16px"
                            inputMode="numeric"
                        />
                        <PinInputField
                            borderRadius="50%"
                            border="1px solid #e3e5e6"
                            _focus={{ borderColor: '#6b4eff' }}
                            w="50px"
                            h="50px"
                            color="#090A0A"
                            fontSize="16px"
                            inputMode="numeric"
                        />
                        <PinInputField
                            borderRadius="50%"
                            border="1px solid #e3e5e6"
                            _focus={{ borderColor: '#6b4eff' }}
                            w="50px"
                            h="50px"
                            color="#090A0A"
                            fontSize="16px"
                            inputMode="numeric"
                        />
                    </PinInput>
                </HStack>

                <Text
                    color="#1b3b5f"
                    fontSize="16px"
                    mt="2rem"
                    fontWeight="500"
                    cursor="pointer"
                    onClick={() => dispatch(userLogin(userData))}>
                    Resend Code
                </Text>
                <Text color="" fontSize="13px" mt=".5rem" fontWeight="500">
                    <b>Note: </b>Check Your Inbox or Spam Folder for OTP code
                </Text>
            </Flex>
        </VerifyContainer>
    );
};

export default LoginVerification;
